import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    let retryTimer: number | undefined;
    let frameA = 0;
    let frameB = 0;

    const scrollToHashTarget = () => {
      if (!hash) {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        return;
      }

      const targetId = decodeURIComponent(hash.slice(1));
      const target = targetId ? document.getElementById(targetId) : null;

      if (target) {
        target.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'auto' });
        return;
      }

      retryTimer = window.setTimeout(() => {
        const delayedTarget = targetId ? document.getElementById(targetId) : null;
        if (delayedTarget) {
          delayedTarget.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'auto' });
          return;
        }

        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      }, 150);
    };

    frameA = window.requestAnimationFrame(() => {
      frameB = window.requestAnimationFrame(scrollToHashTarget);
    });

    return () => {
      window.cancelAnimationFrame(frameA);
      window.cancelAnimationFrame(frameB);
      if (retryTimer) {
        window.clearTimeout(retryTimer);
      }
    };
  }, [pathname, search, hash]);

  return null;
}
